import Header from "../components/Header";

function NotFound() {
    return (
        <div className="flex justify-center items-center h-screen">
            <div className="text-2xl text-center">Oops! It seems you've reached an uncharted section. No worries, let's navigate back to the main portfolio.</div>
        </div>

    );
}
export default NotFound; 